import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { DASHBOARD_URL } from '../config/urls';
import '../styles/LoansHero.css';

const LoansHero = () => {
  const loanFeatures = [
    'Loan options for personal and business needs',
    'Lowest interest rates in the market',
    'Quick disbursal within 24-48 hours',
    'Flexible repayment options'
  ];

  return (
    <section className="loans-hero">
      <div className="container">
        <div className="loans-hero-content">
          <div className="hero-text">
            <span className="eyebrow">FINANCIAL SOLUTIONS</span>
            <h1>Tailored <span className="gradient-text">Loan Products</span> for Every Need</h1>
            <p className="subtitle">From business expansion to personal goals, we've got you covered with flexible loan options and competitive rates.</p>
            
            <ul className="features-list">
              {loanFeatures.map((feature, index) => (
                <li key={index}>
                  <CheckCircle className="feature-icon" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            
            <div className="cta-buttons">
              <a href={DASHBOARD_URL} className="btn btn-primary">
                Apply for Loan
              </a>
              <Link to="/calculator" className="btn btn-outline">
                Calculate EMI
              </Link>
            </div>
          </div>
          
          <div className="loan-cards-preview">
            <div className="loan-card business">
              <div className="card-content">
                <h3>Business Loan</h3>
                <p>Up to ₹50 Lakhs</p>
                <span className="interest">From 10.5%*</span>
              </div>
            </div>
            
            <div className="loan-card personal">
              <div className="card-content">
                <h3>Personal Loan</h3>
                <p>Up to ₹25 Lakhs</p>
                <span className="interest">From 11%*</span>
              </div>
            </div>
            
            <div className="loan-card home">
              <div className="card-content">
                <h3>Home Loan</h3>
                <p>Up to ₹5 Crores</p>
                <span className="interest">From 8.5%*</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoansHero;
